import InvestorInvestments from './investor-investments';

export default InvestorInvestments;
